import { AfterContentChecked, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { LoaderService } from './_core/services/loader.service';
import { ConfigService } from './config.services';
import { TmQueueService } from './_core/services/tm-queue.service';
import { WebStorageService } from './_core/services/webstorage.service';
import { environment } from '@environments/environment';
import { appVersion } from '@environments/version';
import { filter, firstValueFrom } from 'rxjs';
import { WindowsWrapperService } from './_core/services/windows-wrapper.service';
import { QueuesService } from './_core/services/queues.service';
import { Utils } from './_core/helper/Utils';
import { MainControllerComponent } from './pages/queue/dialer/MainController.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentChecked {
  title = 'telemarketing_ui';
  showLoader: boolean = false;
  showHeader = false;
  status: any;
  onDemandLoader: any;

  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    // private dialerService: DialerService,
    private tmQueueService: TmQueueService,
    private activatedRoute: ActivatedRoute,
    private cdref: ChangeDetectorRef,
    private configService: ConfigService,
    private webStorageService:WebStorageService,
    private WindowsWrapper: WindowsWrapperService,
    private queueService: QueuesService,
    private mainController: MainControllerComponent,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showHeader =
          this.activatedRoute !== null &&
          this.activatedRoute.firstChild !== null &&
          this.activatedRoute.firstChild.snapshot.data['showHeader'] !== false;
      }
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        const clientAbbreviation = Utils.fetch('clientAbbreviation');
        const caseDetailsUrl = `/${clientAbbreviation}/Queue/caseDetails`;
        const confirmUserUrl = `/${clientAbbreviation}/Queue/ConfirmUser`;
        if (this.currentUrl !== caseDetailsUrl && this.currentUrl !== confirmUserUrl) {
          let isRecordingAlive = this.queueService.getRecordingStatus();
          if (this.WindowsWrapper.IsWrapper() && isRecordingAlive){
            this.mainController.stopVideoRecording();
          }
        } 
      });
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  ngOnInit() {
    // Log app version for cache busting verification
    console.log('App Version:', appVersion.version);

    const config = this.configService.getConfig();
    //console.log('Config:', config);

    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });

    this.loaderService.onDemandLoading.subscribe((val: boolean) => {
      this.onDemandLoader = val;
    });
    // this.tmQueueService.isReleaseLock.subscribe((val: boolean) => {
    //   if(val)
    //   {
    //      this.releaseLocks1();
    //   }
    // });


    // localStorage.clear();
    // sessionStorage.clear();

    // For inbound & Outbound Queues Only
    //  if (this.activatedRoute.snapshot.url.some(url => url.path.includes('Inbound'))) {
    //     console.log("It's inbound queue..");

    //     this.dialerService.status.subscribe((val: string) => {
    //       this.status = val;
    //     });

    //     this.dialerService.phoneNo.subscribe((val: string) => {
    //       this.phoneNo = val;
    //     });

    //     this.dialerService.waitingForInboundCall.subscribe((val: boolean) => {
    //       this.waitingForInboundCall = val;
    //     });

    //     this.dialerService.showDialer.subscribe((val: boolean) => {
    //       this.showDialer = val;
    //     });
    //     //this.activatedRoute.queryParams.subscribe(params => {});
    //  }
  }

  @HostListener('window:beforeunload', ['$event'])
  async beforeUnloadHandler(event: Event) {
    await this.tmQueueService.releaseLocks().subscribe();
    //console.log('Before unload event');
    //console.log(this.router);
    localStorage.setItem('urlB4Refresh', window.location.href);
    localStorage.setItem('pageRefreshed', 'true');
    if (window.location.href.toLocaleLowerCase().includes('casedetails')) {
      localStorage.setItem('caseDetailsPageRefreshed', 'true');
    }
    event.preventDefault();
  }
  changeUserStatus(event: any) {
    //console.log(event);
    this.status = event;
  }

}
